// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"dH","pgSpeechBox":"dH","speech-list-box":"dI","speechListBox":"dI"};